
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Der englische Begriff «Cluster» bedeutet übersetzt «Häufung». Die
Kopfschmerzattacken treten typischerweise während ein paar Wochen oder Monaten –
vor allem im Frühling und im Herbst – gehäuft auf, bevor sie wieder für Monate
oder gar Jahre verschwinden. Oft treten die Schmerzen auch zur gleichen Stunde
auf. Über die Hälfte der Betroffenen leidet in den frühen Morgenstunden oder ein
bis zwei Stunden nach dem Einschlafen. Im schlimmsten Fall ereignen sich
innerhalb eines Tages acht oder mehr Schmerzattacken. Wer sich an der Forschung
zu den Auslösern von Cluster-Kopfschmerzen beteiligen möchte, kann die «`}<Link href='https://www.kopfschmerz-radar.de/' mdxType="Link">{`Clura – Kopfschmerz-
Radar-App`}</Link>{`» herunterladen und seine Anfallsdaten eingeben.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;